import { StyledTotalContainer, StyledTotalWrapper } from './total-events.styles';
import type { TotalEventsProps } from './total-events.types';
export const TotalEvents = ({
  total
}: TotalEventsProps) => <StyledTotalContainer data-sentry-element="StyledTotalContainer" data-sentry-component="TotalEvents" data-sentry-source-file="total-events.tsx">
    Total events this year <StyledTotalWrapper data-sentry-element="StyledTotalWrapper" data-sentry-source-file="total-events.tsx">{total}</StyledTotalWrapper>
  </StyledTotalContainer>;